module.exports = __webpack_public_path__ + "static/media/privacyPolicy.1f012655.svg";